import { FC } from "react";
import { CandidateStatus } from "../../api/models/EntityCandidate";
import { Icon } from "@chakra-ui/react";
import {
    IconCertificate2,
    IconCircleCheck,
    IconCircleDotted,
    IconCircleX,
    IconCoin,
    IconDotsCircleHorizontal,
    IconForbid,
    IconGavel,
    IconHourglass,
    IconHourglassOff,
} from "@tabler/icons-react";
import { IconProps } from "@chakra-ui/icon";

type StatusDetails = { as: FC; color?: string; title: string };

export const CandidateStatusDetails: Record<CandidateStatus, StatusDetails> = {
    [CandidateStatus.NotScreened]: { as: IconCircleDotted, color: "gray.400", title: "Not Screened" },
    [CandidateStatus.Screening]: { as: IconDotsCircleHorizontal, color: "blue.400", title: "Screening" },
    [CandidateStatus.OptedOut]: { as: IconCircleX, color: "orange.500", title: "Opted Out" },
    [CandidateStatus.Eligible]: { as: IconCircleCheck, color: "green.500", title: "Eligible" },
    [CandidateStatus.NotEligible]: { as: IconForbid, color: "red.500", title: "Not Eligible" },
    [CandidateStatus.NotHired]: { as: IconForbid, color: "gray.600", title: "Not Hired" },
    [CandidateStatus.PendingDocuments]: { as: IconHourglass, color: "yellow.500", title: "Pending Documents" },
    [CandidateStatus.UnableToSubstantiate]: { as: IconForbid, color: "red.500", title: "Unable to Substantiate" },
    [CandidateStatus.ReadyForCertification]: { as: IconCertificate2, color: "yellow.500", title: "Ready for Certification" },
    [CandidateStatus.PendingCertification]: { as: IconCertificate2, color: "blue.500", title: "Pending Certification" },
    [CandidateStatus.Certified]: { as: IconCertificate2, color: "green.600", title: "Certified" },
    [CandidateStatus.Claimed]: { as: IconCoin, color: "green.500", title: "Claimed" },
    [CandidateStatus.Denied]: { as: IconForbid, color: "red.500", title: "Denied" },
    [CandidateStatus.InAppeal]: { as: IconGavel, color: "yellow.500", title: "In Appeal" },
    [CandidateStatus.AppealDenied]: { as: IconForbid, color: "red.800", title: "Appeal Denied" },
    [CandidateStatus.Expired]: { as: IconHourglassOff, color: "gray.500", title: "Expired" },
};

export const CandidateStatusIcon: FC<{ status?: CandidateStatus } & IconProps> = ({ status, ...rest }) => {
    if (status) {
        return <Icon {...CandidateStatusDetails[status]} {...rest} />;
    } else {
        return null;
    }
};

export const getCandidateStatusTitle = (status: CandidateStatus | undefined) => {
    if (status) {
        return CandidateStatusDetails[status].title;
    } else {
        return null;
    }
};
